import { baseSpaDay } from './baseSpaDay';
import { inclusionsWithTimes } from './inclusions';

// Spa Package with No arrival times, time slots support and required and no choice of option
export const scenario5 = {
  ...baseSpaDay,
  configurationGroupsRequireTimeslots: true,
  configurationGroupsSupportTimeslots: true,
  configurationGroups: [...inclusionsWithTimes],
};
